import React from "react";
import styled, { ThemeProvider } from "styled-components";
import { lightTheme } from "./Themes";

import LogoComponent from "../SubComponents/LogoComponent/LogoComponent";
import PowerButton from "../SubComponents/PowerButton/PowerButton";

import BigTitlte from "../SubComponents/BigTitlte";
import SocialIcons from "../SubComponents/SocialIcons";
import ParticleComponent from "../SubComponents/ParticleComponent";

const Box = styled.div`
  background-color: ${(props) => props.theme.body};
  width: 100vw;
  height: 100vh;
  position: relative;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
`;

const ButtonCv = styled.button`
  position: absolute;
  top: 40%;
  padding: 15px;
  border-radius: 11px;
  outline: none;
  border: 1px solid ${(props) => props.theme.text};
  background: transparent;
  color: ${(props) => props.theme.text};
  &:hover {
    color: ${(props) => props.theme.body};
  }
`;
const CvLink = styled.a`
  text-decoration: none;
  text-transform: uppercase;
  color: ${(props) => props.theme.text};
`;
const Warning = styled.p`
  font-size: 2rem;
  color: ${(props) => props.theme.text};
`;

const MySkillsPage = () => {
  return (
    <ThemeProvider theme={lightTheme}>
      <Box>
        <LogoComponent theme="light" />
        <SocialIcons theme="light" />
        <PowerButton />
        <ParticleComponent theme="light" />
        <Warning>Page en cours de développement</Warning>
        <ButtonCv>
          <CvLink href="https://stoyann-open-classrooms.github.io/cv-2022/">
            Voir mon CV{" "}
          </CvLink>
        </ButtonCv>

        <BigTitlte text="SKILLS" top="65%" right="30%" />
      </Box>
    </ThemeProvider>
  );
};

export default MySkillsPage;
